import {
    PortfolioInputWidget,
    WidgetStrategyWithConfig,
} from 'widgets/WidgetRegistry';

import {
    BlotterConfiguration,
    initialBlotterConfiguration,
} from './store/configuration/BlotterConfiguration';
import { selectBlotterConfiguration } from './store/configuration/selectors';
import Blotter from './Blotter';
import { renderBlotterFiltersIndicator } from './filtersModal/BlotterFiltersIndicator';
import { SymbologyValues } from 'app/store/appSettings/AppSettingsState';
import { OrderColumn } from 'communication/types/order/Order';
import uniq from 'lodash/uniq';
import ColumnPortfolio, {
    BlotterColumn,
    buildColumnPortfolio,
} from './columns/ColumnPortfolio';
import State from 'store/State';
import { getBlotterPortfolioInput } from './BlotterPortfolioInput';
import { mapSymbolStreamField } from 'app/store/orders/mapping';
import { ColumnFilterState } from 'widgets/store/grid/filters/FilterState';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { blotterDescription } from './description/blotterDescription';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';

export const blotterWidgetStrategy: PortfolioInputWidget &
    WidgetStrategyWithConfig<BlotterConfiguration> = {
    title: 'Order Blotter',
    supportedHosts: ['layout'],
    reactComponentType: Blotter,
    isInput: true,
    initialConfigState: initialBlotterConfiguration,
    renderFilter: renderBlotterFiltersIndicator,
    getRequiredOrderColumns,
    getPortfolioInput: getBlotterPortfolioInput,
    hiddenInNewportLinkedPalette: true,
    categories: [WidgetCategory.TOP],
    description: blotterDescription,
    portfolioSelectionRequirements: PortfolioSelectionRequirements.None,
};

function getRequiredOrderColumns(
    state: State,
    widgetId: string,
    symbology: SymbologyValues
): OrderColumn[] {
    const columnPortfolio = buildColumnPortfolio(symbology);
    const blotterConfiguration = selectBlotterConfiguration(
        state,
        widgetId,
        columnPortfolio
    );

    const blotterColumns = [
        ...blotterConfiguration.visibleColumns,
        ...blotterConfiguration.filters
            .filter(
                (filter): filter is ColumnFilterState<BlotterColumn> =>
                    'column' in filter
            )
            .map((filter) => filter.column),
    ];

    const orderColumns = blotterColumns
        .map((c) => mapToOrderColumns(columnPortfolio, c, symbology))
        .filter((a) => a !== undefined);

    return uniq(orderColumns);
}

function mapToOrderColumns(
    columnPortfolio: ColumnPortfolio,
    columnPortfolioColumnName: BlotterColumn,
    symbology: SymbologyValues
): OrderColumn {
    if (columnPortfolioColumnName === 'symbol') {
        return mapSymbolStreamField(symbology);
    }

    return columnPortfolio[columnPortfolioColumnName].dataField as OrderColumn;
}
